// extracted by mini-css-extract-plugin
module.exports = {"slider-container":"customCarousel_slider-container__1qmJv"};